var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"href":_vm.url,"target":"_blank","color":"vor"}},'v-btn',_vm.headerButtonSize,false),[_c('v-img',{attrs:{"src":require('@/assets/vor-icon-36.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }